import { Message } from '../../Message';

export class Rehash extends Message {
	static readonly COMMAND = 'REHASH';
}
